export const HANDLE_CHANGE = 'HANDLE_DATE_CHANGE';

export const handleChange = (state, value) => {
  return {
    state,
    type: HANDLE_CHANGE,
    value
  };
};
